module.exports = __webpack_public_path__ + "f3e641f221c4860267d40f856cc4be86.MP3";